<template>
    <div class="reward-rule-box">
        <el-table :data="tableData"
                border style="width: 100%">
            <el-table-column
                    prop="pro_title"
                    :label="proName + '分类'"
                    width="" />
            <el-table-column
                    prop="reward_type"
                    label="提成方式"
                    width="">
                <template slot-scope="data">
                    <el-select v-model="data.row.reward_type" placeholder="请选择" :disabled="disabled">
                        <el-option
                                v-for="item in rewardArr"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column
                    v-if="proType === 1"
                    label="会员点客提成点" >
                <template slot-scope="data">
                    <el-input size="small" placeholder="" v-model="data.row.user_assign_reward_data" @change="change" :disabled="disabled">
                        <template slot="append">
                            <span class="input-icon" v-if="data.row.reward_type === '1'">¥</span>
                            <span class="input-icon" v-else>%</span>
                        </template>
                    </el-input>
                </template>
            </el-table-column>
            <el-table-column
                    v-if="proType === 1"
                    label="会员非点客提成点" >
                <template slot-scope="data">
                    <el-input size="small" placeholder="" v-model="data.row.user_reward_data" @change="change" :disabled="disabled">
                        <template slot="append">
                            <span class="input-icon" v-if="data.row.reward_type === '1'">¥</span>
                            <span class="input-icon" v-else>%</span>
                        </template>
                    </el-input>
                </template>
            </el-table-column>
            <el-table-column
                    v-if="proType === 1"
                    label="散客点客提成点" >
                <template slot-scope="data">
                    <el-input size="small" placeholder="" v-model="data.row.assign_reward_data" @change="change" :disabled="disabled">
                        <template slot="append">
                            <span class="input-icon" v-if="data.row.reward_type === '1'">¥</span>
                            <span class="input-icon" v-else>%</span>
                        </template>
                    </el-input>
                </template>
            </el-table-column>
            <el-table-column
                    v-if="proType === 1"
                    label="散客非点客提成点" >
                <template slot-scope="data">
                    <el-input size="small" placeholder="" v-model="data.row.reward_data" @change="change" :disabled="disabled">
                        <template slot="append">
                            <span class="input-icon" v-if="data.row.reward_type === '1'">¥</span>
                            <span class="input-icon" v-else>%</span>
                        </template>
                    </el-input>
                </template>
            </el-table-column>
            <el-table-column
                    v-else
                    label="提成" >
                <template slot-scope="data">
                    <el-input size="small" placeholder="" v-model="data.row.reward_data" @change="change" style="width: 200px" :disabled="disabled">
                        <template slot="append">
                            <span class="input-icon" v-if="data.row.reward_type === '1'">¥</span>
                            <span class="input-icon" v-else>%</span>
                        </template>
                    </el-input>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    export default {
        name: "StaffRewardOptionBodyRule",
        props: {
            proType: {
                type: Number,
                default: 0
            },
            ruleData: {
                type: Array,
                default: () => ([]),
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            proName: "",
            tableData: [

            ],

            rewardArr: [
                {
                    label: "固定金额提成",
                    value: "1"
                }, {
                    label: "折后金额提成",
                    value: "2"
                }
            ],
            type: {
                product: 1,
                goods: 2,
                card: 5
            }
        }),
        mounted: function () {
            this.init();
        },
        methods: {
            //初始化
            init: function () {
                if(this.proType === this.type.product) {
                    this.proName = "项目";

                }else if(this.proType === this.type.goods) {
                    this.proName = "商品";

                }else if(this.proType === this.type.card) {
                    this.proName = "卡项";
                }
            },

            //改变设置
            change: function () {
                this.$emit("change", this.tableData);
            }
        },
        watch: {
            proType: function () {
                this.init();
            },
            ruleData: function (data) {
                let newVal = [];
                if(data) {
                    data.forEach(val => {
                        if(!val.reward_type) val.reward_type = "2";
                        newVal.push(val);
                    });
                }
                this.tableData = newVal;
            }
        }
    }
</script>

<style scoped>
    .reward-rule-box{
        padding-bottom: 10px;
    }
    .input-icon{
        display: inline-block;
        width: 10px;
    }
</style>
